// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3byDM","inputDescription":"styles_inputDescription__1O1n5"};